// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Navbar — slim fixed top bar + fullscreen overlay menu
   ============================================================ */

/* ── Top bar ─────────────────────────────────────────────────── */
.fg-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 200;
  background: var(--c-forest);
}

.fg-nav__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  padding-block: 0;
}

/* Brand */
.fg-nav__brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  text-decoration: none;
  color: var(--c-sand);
  flex-shrink: 0;
}

.fg-nav__wordmark {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  line-height: 1.2;
  color: var(--c-sand);
}

.fg-nav__sub-word {
  font-size: 0.6rem;
  letter-spacing: 0.28em;
  opacity: 0.55;
}

/* Right controls */
.fg-nav__controls {
  display: flex;
  align-items: center;
  gap: 0;
}

/* Apply text link */
.fg-nav__apply {
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--c-sand);
  text-decoration: none;
  padding: 0.6rem 1.2rem;
  transition: color var(--dur) var(--ease);
}
.fg-nav__apply:hover {
  color: var(--accent);
}

/* Donate filled button */
.fg-nav__donate-btn {
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--on-accent);
  text-decoration: none;
  background: var(--accent);
  padding: 0.6rem 1.2rem;
  transition: background var(--dur) var(--ease);
}
.fg-nav__donate-btn:hover {
  background: var(--accent-hover);
  color: var(--on-accent);
}

/* Hamburger button */
.fg-nav__menu-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.6rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hamburger icon — 2 lines that animate to × */
.fg-nav__burger {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 22px;
}

.fg-nav__burger-line {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--c-sand);
  border-radius: 2px;
  transition:
    transform 0.3s var(--ease),
    opacity 0.2s;
  transform-origin: center;
}

.fg-nav__burger-line.top-open {
  transform: translateY(3.5px) rotate(45deg);
}
.fg-nav__burger-line.btm-open {
  transform: translateY(-3.5px) rotate(-45deg);
}

/* ── Fullscreen overlay ─────────────────────────────────────── */

/* Dark scrim behind panel */
.fg-menu__backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 14, 10, 0.55);
  z-index: 299;
  backdrop-filter: blur(2px);
}

/* Slide-in panel — from right, full screen */
.fg-menu {
  position: fixed;
  inset: 0;
  background: var(--c-forest);
  z-index: 300;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;

  /* Subtle noise texture feel */
  background-image: radial-gradient(ellipse at 80% 50%, rgba(95, 113, 88, 0.3) 0%, transparent 70%);
}

/* Panel head */
.fg-menu__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 clamp(1.5rem, 5vw, 4rem);
  min-height: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

/* Brand inside menu */
.fg-menu__brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  text-decoration: none;
}

.fg-menu__wordmark {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  line-height: 1.2;
  color: var(--c-sand);
}

.fg-menu__sub {
  font-size: 0.6rem;
  letter-spacing: 0.28em;
  opacity: 0.55;
}

/* Close button */
.fg-menu__close {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(220, 204, 180, 0.55);
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  transition: color var(--dur) var(--ease);
}
.fg-menu__close:hover {
  color: var(--c-sand);
}

.fg-menu__close-x {
  font-size: 1.1rem;
  font-weight: 400;
  opacity: 0.7;
}

/* ── Nav links list ── */
.fg-menu__nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: clamp(1.5rem, 4vh, 3rem) clamp(1.5rem, 5vw, 4rem) clamp(1rem, 2vh, 2rem);
  gap: 0;
}

.fg-menu__item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.fg-menu__num {
  font-family: var(--font-body);
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  color: var(--accent);
  width: clamp(2rem, 4vw, 3.5rem);
  flex-shrink: 0;
}

.fg-menu__link {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: var(--font-display);
  font-size: clamp(1.5rem, 4.5vw, 3.5rem);
  font-weight: 400;
  text-transform: uppercase;
  color: var(--c-sand);
  text-decoration: none;
  padding: clamp(0.5rem, 1.5vh, 1rem) 0;
  letter-spacing: 0.02em;
  line-height: 1;
  transition:
    color var(--dur) var(--ease),
    letter-spacing var(--dur) var(--ease);
}

.fg-menu__link:hover,
.fg-menu__link--active {
  color: var(--accent);
  letter-spacing: 0.04em;
}

.fg-menu__arrow {
  font-size: clamp(0.9rem, 1.5vw, 1.25rem);
  opacity: 0;
  transform: translateX(-8px);
  transition:
    opacity 0.3s var(--ease),
    transform 0.3s var(--ease);
}

.fg-menu__link:hover .fg-menu__arrow,
.fg-menu__link--active .fg-menu__arrow {
  opacity: 1;
  transform: translateX(0);
}

/* ── Menu footer ── */
.fg-menu__footer {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: clamp(1.5rem, 4vw, 3rem);
  padding: clamp(1.25rem, 3vh, 2rem) clamp(1.5rem, 5vw, 4rem);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  flex-shrink: 0;
}

/* Socials */
.fg-menu__socials {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.fg-menu__social-label {
  font-family: var(--font-body);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(220, 204, 180, 0.4);
  margin: 0;
}

.fg-menu__social-icons {
  display: flex;
  gap: 0.9rem;
}

.fg-menu__social-link {
  color: rgba(220, 204, 180, 0.55);
  font-size: 1.05rem;
  text-decoration: none;
  transition: color var(--dur) var(--ease);
}
.fg-menu__social-link:hover {
  color: var(--accent);
}

/* Tagline */
.fg-menu__tagline {
  font-family: var(--font-body);
  font-size: clamp(0.72rem, 0.9vw, 0.82rem);
  color: rgba(220, 204, 180, 0.4);
  line-height: 1.6;
  margin: 0;
  max-width: 22rem;
}

/* Questions CTA */
.fg-menu__contact-cta {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  text-decoration: none;
  border: 1px solid rgba(220, 204, 180, 0.2);
  border-radius: var(--radius-sm);
  padding: 0.75rem 1rem;
  transition:
    border-color var(--dur) var(--ease),
    background var(--dur) var(--ease);
}
.fg-menu__contact-cta:hover {
  border-color: var(--accent);
  background: rgba(168, 102, 66, 0.08);
}

.fg-menu__contact-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.fg-menu__contact-ql {
  font-family: var(--font-body);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(220, 204, 180, 0.45);
  margin: 0;
}

.fg-menu__contact-gl {
  font-family: var(--font-body);
  font-size: 0.78rem;
  font-weight: 500;
  color: var(--c-sand);
  margin: 0.1rem 0 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.fg-menu__contact-arrow {
  font-size: 0.65rem;
}

/* Mobile-only CTAs — hidden on desktop */
.fg-menu__mobile-ctas {
  display: none;
}

/* ── Responsive ─────────────────────────────────────────────── */
@media (max-width: 767.98px) {
  .fg-menu__footer {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .fg-menu__tagline {
    display: none;
  }

  .fg-menu__mobile-ctas {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem;
    margin-top: 0.25rem;
  }

  .fg-menu__mobile-apply,
  .fg-menu__mobile-donate {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-body);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    text-decoration: none;
    padding: 0.9rem;
  }

  .fg-menu__mobile-apply {
    border: 1.5px solid rgba(220, 204, 180, 0.4);
    color: var(--c-sand);
    background: transparent;
  }

  .fg-menu__mobile-donate {
    background: var(--accent);
    color: var(--on-accent);
    border: none;
  }
}

@media (max-width: 479.98px) {
  .fg-menu__link {
    font-size: clamp(1.8rem, 10vw, 2.8rem);
  }
}

/* ── Sign In button in public navbar ── */
.fg-nav__signin-btn {
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--c-sand);
  text-decoration: none;
  padding: 0.5rem 0.9rem;
  border: 1.5px solid rgba(220, 204, 180, 0.35);
  border-radius: 3px;
  transition:
    border-color 0.2s,
    color 0.2s,
    background 0.2s;
  white-space: nowrap;
}
.fg-nav__signin-btn:hover {
  border-color: var(--c-sand);
  color: #fff;
  background: rgba(220, 204, 180, 0.1);
}

/* Sign-in: in the bar on larger screens, inside the menu on phones */
.fg-menu__mobile-signin { grid-column: 1 / -1; }
@media (max-width: 599.98px) {
  .fg-nav__signin-btn { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE,mEAAmE;AACnE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB;;gBAEc;EACd,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,4CAA4C;AAC9C;;AAEA,kEAAkE;;AAElE,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;;EAElB,8BAA8B;EAC9B,iGAAiG;AACnG;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iFAAiF;EACjF,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;EACrC,sBAAsB;EACtB,cAAc;EACd;;yCAEuC;AACzC;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,UAAU;EACV,2BAA2B;EAC3B;;8BAE4B;AAC9B;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,2DAA2D;EAC3D,+CAA+C;EAC/C,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,oBAAoB;AACtB;;AAEA,YAAY;AACZ;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,+BAA+B;EAC/B,qBAAqB;EACrB;;qCAEmC;AACrC;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,aAAa;AACf;;AAEA,kEAAkE;AAClE;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,4CAA4C;IAC5C,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;EAC7C,kBAAkB;EAClB;;;mBAGiB;EACjB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,oCAAoC;AACtC;;AAEA,qEAAqE;AACrE,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,sBAAsB,aAAa,EAAE;AACvC","sourcesContent":["/* ============================================================\n   Navbar — slim fixed top bar + fullscreen overlay menu\n   ============================================================ */\n\n/* ── Top bar ─────────────────────────────────────────────────── */\n.fg-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 200;\n  background: var(--c-forest);\n}\n\n.fg-nav__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 60px;\n  padding-block: 0;\n}\n\n/* Brand */\n.fg-nav__brand {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  text-decoration: none;\n  color: var(--c-sand);\n  flex-shrink: 0;\n}\n\n.fg-nav__wordmark {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.78rem;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  color: var(--c-sand);\n}\n\n.fg-nav__sub-word {\n  font-size: 0.6rem;\n  letter-spacing: 0.28em;\n  opacity: 0.55;\n}\n\n/* Right controls */\n.fg-nav__controls {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n/* Apply text link */\n.fg-nav__apply {\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--c-sand);\n  text-decoration: none;\n  padding: 0.6rem 1.2rem;\n  transition: color var(--dur) var(--ease);\n}\n.fg-nav__apply:hover {\n  color: var(--accent);\n}\n\n/* Donate filled button */\n.fg-nav__donate-btn {\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: var(--on-accent);\n  text-decoration: none;\n  background: var(--accent);\n  padding: 0.6rem 1.2rem;\n  transition: background var(--dur) var(--ease);\n}\n.fg-nav__donate-btn:hover {\n  background: var(--accent-hover);\n  color: var(--on-accent);\n}\n\n/* Hamburger button */\n.fg-nav__menu-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.6rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Hamburger icon — 2 lines that animate to × */\n.fg-nav__burger {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: 22px;\n}\n\n.fg-nav__burger-line {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: var(--c-sand);\n  border-radius: 2px;\n  transition:\n    transform 0.3s var(--ease),\n    opacity 0.2s;\n  transform-origin: center;\n}\n\n.fg-nav__burger-line.top-open {\n  transform: translateY(3.5px) rotate(45deg);\n}\n.fg-nav__burger-line.btm-open {\n  transform: translateY(-3.5px) rotate(-45deg);\n}\n\n/* ── Fullscreen overlay ─────────────────────────────────────── */\n\n/* Dark scrim behind panel */\n.fg-menu__backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 14, 10, 0.55);\n  z-index: 299;\n  backdrop-filter: blur(2px);\n}\n\n/* Slide-in panel — from right, full screen */\n.fg-menu {\n  position: fixed;\n  inset: 0;\n  background: var(--c-forest);\n  z-index: 300;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  /* Subtle noise texture feel */\n  background-image: radial-gradient(ellipse at 80% 50%, rgba(95, 113, 88, 0.3) 0%, transparent 70%);\n}\n\n/* Panel head */\n.fg-menu__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 clamp(1.5rem, 5vw, 4rem);\n  min-height: 60px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n/* Brand inside menu */\n.fg-menu__brand {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  text-decoration: none;\n}\n\n.fg-menu__wordmark {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.78rem;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  line-height: 1.2;\n  color: var(--c-sand);\n}\n\n.fg-menu__sub {\n  font-size: 0.6rem;\n  letter-spacing: 0.28em;\n  opacity: 0.55;\n}\n\n/* Close button */\n.fg-menu__close {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: rgba(220, 204, 180, 0.55);\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  transition: color var(--dur) var(--ease);\n}\n.fg-menu__close:hover {\n  color: var(--c-sand);\n}\n\n.fg-menu__close-x {\n  font-size: 1.1rem;\n  font-weight: 400;\n  opacity: 0.7;\n}\n\n/* ── Nav links list ── */\n.fg-menu__nav {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: clamp(1.5rem, 4vh, 3rem) clamp(1.5rem, 5vw, 4rem) clamp(1rem, 2vh, 2rem);\n  gap: 0;\n}\n\n.fg-menu__item {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n}\n\n.fg-menu__num {\n  font-family: var(--font-body);\n  font-size: 0.65rem;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n  color: var(--accent);\n  width: clamp(2rem, 4vw, 3.5rem);\n  flex-shrink: 0;\n}\n\n.fg-menu__link {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-family: var(--font-display);\n  font-size: clamp(1.5rem, 4.5vw, 3.5rem);\n  font-weight: 400;\n  text-transform: uppercase;\n  color: var(--c-sand);\n  text-decoration: none;\n  padding: clamp(0.5rem, 1.5vh, 1rem) 0;\n  letter-spacing: 0.02em;\n  line-height: 1;\n  transition:\n    color var(--dur) var(--ease),\n    letter-spacing var(--dur) var(--ease);\n}\n\n.fg-menu__link:hover,\n.fg-menu__link--active {\n  color: var(--accent);\n  letter-spacing: 0.04em;\n}\n\n.fg-menu__arrow {\n  font-size: clamp(0.9rem, 1.5vw, 1.25rem);\n  opacity: 0;\n  transform: translateX(-8px);\n  transition:\n    opacity 0.3s var(--ease),\n    transform 0.3s var(--ease);\n}\n\n.fg-menu__link:hover .fg-menu__arrow,\n.fg-menu__link--active .fg-menu__arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* ── Menu footer ── */\n.fg-menu__footer {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: clamp(1.5rem, 4vw, 3rem);\n  padding: clamp(1.25rem, 3vh, 2rem) clamp(1.5rem, 5vw, 4rem);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  flex-shrink: 0;\n}\n\n/* Socials */\n.fg-menu__socials {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.fg-menu__social-label {\n  font-family: var(--font-body);\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(220, 204, 180, 0.4);\n  margin: 0;\n}\n\n.fg-menu__social-icons {\n  display: flex;\n  gap: 0.9rem;\n}\n\n.fg-menu__social-link {\n  color: rgba(220, 204, 180, 0.55);\n  font-size: 1.05rem;\n  text-decoration: none;\n  transition: color var(--dur) var(--ease);\n}\n.fg-menu__social-link:hover {\n  color: var(--accent);\n}\n\n/* Tagline */\n.fg-menu__tagline {\n  font-family: var(--font-body);\n  font-size: clamp(0.72rem, 0.9vw, 0.82rem);\n  color: rgba(220, 204, 180, 0.4);\n  line-height: 1.6;\n  margin: 0;\n  max-width: 22rem;\n}\n\n/* Questions CTA */\n.fg-menu__contact-cta {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  text-decoration: none;\n  border: 1px solid rgba(220, 204, 180, 0.2);\n  border-radius: var(--radius-sm);\n  padding: 0.75rem 1rem;\n  transition:\n    border-color var(--dur) var(--ease),\n    background var(--dur) var(--ease);\n}\n.fg-menu__contact-cta:hover {\n  border-color: var(--accent);\n  background: rgba(168, 102, 66, 0.08);\n}\n\n.fg-menu__contact-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.fg-menu__contact-ql {\n  font-family: var(--font-body);\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(220, 204, 180, 0.45);\n  margin: 0;\n}\n\n.fg-menu__contact-gl {\n  font-family: var(--font-body);\n  font-size: 0.78rem;\n  font-weight: 500;\n  color: var(--c-sand);\n  margin: 0.1rem 0 0;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.fg-menu__contact-arrow {\n  font-size: 0.65rem;\n}\n\n/* Mobile-only CTAs — hidden on desktop */\n.fg-menu__mobile-ctas {\n  display: none;\n}\n\n/* ── Responsive ─────────────────────────────────────────────── */\n@media (max-width: 767.98px) {\n  .fg-menu__footer {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n\n  .fg-menu__tagline {\n    display: none;\n  }\n\n  .fg-menu__mobile-ctas {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.6rem;\n    margin-top: 0.25rem;\n  }\n\n  .fg-menu__mobile-apply,\n  .fg-menu__mobile-donate {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: var(--font-body);\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    text-decoration: none;\n    padding: 0.9rem;\n  }\n\n  .fg-menu__mobile-apply {\n    border: 1.5px solid rgba(220, 204, 180, 0.4);\n    color: var(--c-sand);\n    background: transparent;\n  }\n\n  .fg-menu__mobile-donate {\n    background: var(--accent);\n    color: var(--on-accent);\n    border: none;\n  }\n}\n\n@media (max-width: 479.98px) {\n  .fg-menu__link {\n    font-size: clamp(1.8rem, 10vw, 2.8rem);\n  }\n}\n\n/* ── Sign In button in public navbar ── */\n.fg-nav__signin-btn {\n  font-family: var(--font-body);\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--c-sand);\n  text-decoration: none;\n  padding: 0.5rem 0.9rem;\n  border: 1.5px solid rgba(220, 204, 180, 0.35);\n  border-radius: 3px;\n  transition:\n    border-color 0.2s,\n    color 0.2s,\n    background 0.2s;\n  white-space: nowrap;\n}\n.fg-nav__signin-btn:hover {\n  border-color: var(--c-sand);\n  color: #fff;\n  background: rgba(220, 204, 180, 0.1);\n}\n\n/* Sign-in: in the bar on larger screens, inside the menu on phones */\n.fg-menu__mobile-signin { grid-column: 1 / -1; }\n@media (max-width: 599.98px) {\n  .fg-nav__signin-btn { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
